module.exports = __webpack_public_path__ + "static/media/VISION.1959ef9f.jpg";